import { Injectable, Inject } from '@angular/core';
import { L10N_LOCALE, L10nLocale } from 'angular-l10n';
import { DeviceDetectorService } from 'ngx-device-detector';

@Injectable({
  providedIn: 'root'
})
export class SessionService {

  isMobile: boolean;

  constructor(
    @Inject(L10N_LOCALE) public l10nLocale: L10nLocale,
    private deviceService: DeviceDetectorService
  ) {
    this.isMobile = this.deviceService.isMobile();
  }

  get locale(): string {
    let culture = this.l10nLocale.language.substring(0, 2);

    return culture || 'it';
  }  

  destroy() {
  
  }  
}
